import React, { useState } from 'react';
import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend);

const REC_COLORS = { discount: '#ffaa00', liquidate: '#ff6b9d', write_off: '#ff4444' };
const REC_LABELS = { discount: '🏷️ Discount', liquidate: '🔥 Liquidate', write_off: '❌ Write Off' };

export default function DeadStock({ data }) {
  const [sortBy, setSortBy] = useState('value');
  if (!data || !data.length) return (
    <div className="inv-empty inv-empty-good">
      <span>✅</span><h3>No Dead Stock Detected</h3>
      <p>All products have sales activity in the last 90 days</p>
    </div>
  );

  const totalValue = data.reduce((s, d) => s + d.inventory_value, 0);
  const totalCost = data.reduce((s, d) => s + d.cost_tied_up, 0);
  const sorted = [...data].sort((a, b) => {
    if (sortBy === 'value') return b.inventory_value - a.inventory_value;
    if (sortBy === 'days') return b.days_since_sale - a.days_since_sale;
    return b.quantity - a.quantity;
  });

  const recCounts = { discount: 0, liquidate: 0, write_off: 0 };
  data.forEach(d => recCounts[d.recommendation]++);
  const doughnutData = {
    labels: ['Discount', 'Liquidate', 'Write Off'],
    datasets: [{ data: [recCounts.discount, recCounts.liquidate, recCounts.write_off], backgroundColor: ['#ffaa0040','#ff6b9d40','#ff444440'], borderColor: ['#ffaa00','#ff6b9d','#ff4444'], borderWidth: 2, hoverOffset: 8 }]
  };

  return (
    <div className="inv-chart-container">
      <h2 className="inv-chart-title">
        <span>💀</span> Dead Stock Analysis
        <span className="inv-badge inv-badge-danger">{data.length} items</span>
      </h2>
      <div className="inv-dead-summary">
        <div className="inv-summary-card inv-summary-danger">
          <span className="inv-summary-label">Retail Value Tied Up</span>
          <span className="inv-summary-value">AED {totalValue.toLocaleString()}</span>
        </div>
        <div className="inv-summary-card inv-summary-warning">
          <span className="inv-summary-label">Cost Tied Up</span>
          <span className="inv-summary-value">AED {totalCost.toLocaleString()}</span>
        </div>
        <div style={{ height: '140px' }}>
          <Doughnut data={doughnutData} options={{ responsive: true, maintainAspectRatio: false, cutout: '65%', plugins: { legend: { labels: { color: '#a0a0b0' } } } }} />
        </div>
      </div>
      <div className="inv-sort-controls">
        <span>Sort by:</span>
        {['value','days','qty'].map(s => <button key={s} className={sortBy === s ? 'active' : ''} onClick={() => setSortBy(s)}>{s.charAt(0).toUpperCase()+s.slice(1)}</button>)}
      </div>
      <div className="inv-list">
        {sorted.map((item, i) => (
          <div key={i} className="inv-dead-item">
            <div className="inv-rank">{i + 1}</div>
            <div className="inv-item-info">
              <span className="inv-item-title">{item.title}</span>
              {item.variant_title && item.variant_title !== 'Default Title' && <span className="inv-item-sub">{item.variant_title}</span>}
              {item.sku && <span className="inv-item-sku">{item.sku}</span>}
            </div>
            <div className="inv-stats">
              <div className="inv-stat"><span>Qty</span><span>{item.quantity}</span></div>
              <div className="inv-stat"><span>Value</span><span>AED {item.inventory_value.toLocaleString()}</span></div>
              <div className="inv-stat"><span>Days Silent</span><span>{item.days_since_sale}d</span></div>
            </div>
            <div className="inv-rec" style={{ color: REC_COLORS[item.recommendation] }}>{REC_LABELS[item.recommendation]}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
